// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "feature-app." + chunkId + "." + {"143":"7b55efecbd6d97d586a2","158":"b00bcb59fdcab79e6565","172":"e2b82075b91ab3563141","715":"347723d68336ac5eb87c","758":"bba9e192174bd0f47eaa"}[chunkId] + ".js";
};